import { useState } from 'react';
import { Button, Box, Typography, Paper } from '@mui/material';
import { BugReport as BugIcon } from '@mui/icons-material';

/**
 * Test component to verify ErrorBoundary is working correctly.
 * Only visible in development mode.
 * 
 * Usage: Add <TestErrorButton /> anywhere in your app during development
 * to test error boundary functionality.
 */
export const TestErrorButton = () => {
  const [shouldThrow, setShouldThrow] = useState(false);

  // Only show in development
  if (!import.meta.env.DEV) {
    return null;
  }

  if (shouldThrow) {
    throw new Error('Test Error: ErrorBoundary is working correctly! 🎉');
  }

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        p: 2,
        zIndex: 9999,
        bgcolor: 'warning.light',
        border: '2px dashed',
        borderColor: 'warning.main',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'center' }}>
        <Typography variant="caption" fontWeight="bold">
          DEV MODE ONLY
        </Typography>
        <Button
          variant="contained"
          color="error"
          size="small"
          startIcon={<BugIcon />}
          onClick={() => setShouldThrow(true)}
        >
          Test Error Boundary
        </Button>
      </Box>
    </Paper>
  );
};
